const STATUS_JSON = {
  0: {
    className: 'cancelled',
    value: '已取消'
  },
  1: {
    className: 'waitInquiry',
    value: '待开方'
  },
  2: {
    className: 'closed',
    value: '已关闭'
  },
  3: {
    className: 'overTime',
    value: '已超时'
  }
}
const STATUS_ELSE = {
  1: {
    className: 'waitAudited',
    value: '待审核'
  },
  2: {
    className: 'audited',
    value: '已通过'
  },
  3: {
    className: 'auditFail',
    value: '已驳回'
  },
  5: {
    className: 'audited',
    value: '已完成'
  }
}
function fetchStatus(status, auditStatus) {
  if (status >= 4) {
    if (auditStatus >= 1 && auditStatus <=3) {
      return STATUS_ELSE[auditStatus]
    }
    // *****山东药店******
    if (auditStatus == 5){
      return STATUS_ELSE[auditStatus]
    }
    // *******
    if (auditStatus == 7){
      return STATUS_ELSE[1]  // 医院药师审核 7 也是待审核状
    }
    if(auditStatus == 8){
       return STATUS_ELSE[3] // 已经驳回
    }
    return {
      className: '',
      value: ''
    }
  }
  return STATUS_JSON[status];
}
module.exports = fetchStatus;